import React from 'react';
import { useAppState } from 'AppProvider';
import {
  StyledWrapInput,
  StyledLabel,
  ErrorContainer,
  Error,
} from 'components/theme/Form';
import PhoneNumberInput from 'components/common/PhoneNumberInput/PhoneNumberInput';
import { ITextFieldProps } from 'components/common/TextFieldInput/TextFieldInput';
import { Controller, useFormContext } from 'react-hook-form';

interface PhoneNumberControllerProps extends ITextFieldProps {
  onTelephoneCountryCodeChange: (countryCode: string) => void;
  telephoneCountryCode: string;
}

const PhoneNumberController = ({
  autoComplete,
  label,
  name,
  onTelephoneCountryCodeChange,
  telephoneCountryCode,
  ...props
}: PhoneNumberControllerProps) => {
  const { control, trigger } = useFormContext();
  const { settings } = useAppState(
    (state: Record<string, unknown>) => state.brand,
  );

  const inputId = `input-${name.replace(/\./g, '-')}`;
  const errorId = `error-${inputId}`;

  return (
    <Controller
      control={control}
      render={({ field, fieldState }) => {
        const errorMessage = fieldState.error?.message as string | undefined;
        return (
          <StyledWrapInput>
            <StyledLabel htmlFor={inputId}>{label}</StyledLabel>
            <PhoneNumberInput
              countryCode={settings?.countryCode}
              countryCodeEditable
              inputProps={{
                name,
                id: inputId,
                placeholder: '+1 (702) 123-4567',
                autoComplete,
                'aria-invalid': !!errorMessage,
                'aria-describedby': errorMessage ? errorId : undefined,
                onBlur: () => {
                  field.onBlur();
                  trigger(name);
                },
              }}
              inputRef={field.ref}
              onChange={field.onChange}
              onTelephoneCountryCodeChange={onTelephoneCountryCodeChange}
              telephoneCountryCode={telephoneCountryCode}
              value={field.value}
            />
            {errorMessage && (
              <ErrorContainer
                id={errorId}
                role="alert"
                aria-live="assertive"
                tabIndex={-1}
              >
                <Error>{errorMessage}</Error>
              </ErrorContainer>
            )}
          </StyledWrapInput>
        );
      }}
      name={name}
      {...props}
    />
  );
};

export default PhoneNumberController;
